var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-main" },
    [
      _c("billboards", {
        ref: "billboard",
        attrs: {
          bannerHeight: _vm.GET_bannerHeight_16_9_Fun,
          swipeAuto: _vm.swipeAuto,
          billboardList: _vm.billboardList,
        },
        on: { "click-banner": _vm.clickBanner },
      }),
      _vm._v(" "),
      _c("recommend", {
        attrs: { recommendList: _vm.recommendList, imgWidth: "44" },
        on: { "click-icon": _vm.clickRecomend },
      }),
      _vm._v(" "),
      _c("banner"),
      _vm._v(" "),
      _c("topic-list"),
      _vm._v(" "),
      _c("popular", [
        _c(
          "div",
          { staticClass: "license", on: { click: _vm.toLicense } },
          [
            _c("lazy-img", {
              attrs: {
                src: _vm.licenseBanner,
                width: "100%",
                height: "26.7vw",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("act-tip"),
      _vm._v(" "),
      _c("act-float-layer"),
      _vm._v(" "),
      _c("to-top-btn"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }